module.exports = __webpack_public_path__ + "img/20200514_143707.4a34bb45.jpg";